import { getGuid, isBot, isStaff } from 'chairisher/context/auth';
import { getHoneybadgerJsApiKey, isHoneybadgerJsEnabled } from 'chairisher/context/honeybadger';
import { getReleaseTag } from 'chairisher/context/site';
import { isServerErrorResponse } from 'chairisher/util/status';

let isHoneybadgerConfigured;

const ignoredNames = [
    'ChunkLoadError', // @todo (CHAIR-18206)
    'DataCloneError', // @todo (CHAIR-18196)
    'ScriptError',
];

const ignoredMessages = [
    'Invalid value for token creation parameter: address_line1 should be a string', // @todo (CHAIR-18202)
    'The selector you specified (.js-express-payment-request-button-wrapper) applies to no DOM elements', // @todo (CHAIR-18197)
    'UnhandledPromiseRejectionWarning: Unspecified reason', // intentionally ignored to reduce noise in logs; will remain indefinitely.
];

/**
 * Sends an error to Honeybadger with contextual metadata.
 *
 * @param {Object} params
 * @param {Object|String} params.err The error object or message to report.
 * @param {Object=} params.context Additional context to include in the error report.
 * @param {Array=} params.tags Optional tags to include in the error report for grouping.
 */
export default async function notifyHoneybadger({ err, context = {}, tags = [] }) {
    if (isHoneybadgerJsEnabled() && !isBot()) {
        const { default: Honeybadger } = await import('@honeybadger-io/js');

        if (!isHoneybadgerConfigured) {
            Honeybadger.configure({
                apiKey: getHoneybadgerJsApiKey(),
                developmentEnvironments: [],
                environment: process.env.NODE_ENV,
                maxErrors: 5,
                revision: getReleaseTag(),
            });

            // allow only manually reported errors that do NOT contain the specified errors, messages, or statuses
            Honeybadger.beforeNotify((notice) => {
                const isReportedManually = notice.context?.reportedManually === true;

                const isIgnoredName = ignoredNames.includes(notice.name);
                const isIgnoredMessage = ignoredMessages.some((substring) => notice.message.includes(substring));
                const isIgnoredStatus = isServerErrorResponse(notice.status);

                return isReportedManually && !(isIgnoredName || isIgnoredMessage || isIgnoredStatus);
            });

            isHoneybadgerConfigured = true;
        }

        Honeybadger.notify(err, {
            context: { reportedManually: true, isStaff: isStaff(), userGuid: getGuid(), ...context },
            tags: ['manual', ...tags],
        });
    }
}
